import React from "react";
import "./style.css";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';


export const CourseLandingImageGallery = ({ images, numrows = 3, mobile }) => {

  if (document.body.clientWidth <= 576)
    return (
      <Swiper
        centeredSlides={true}
        slidesPerView={1.25}
        observer={false}
        observeParents={false}
        spaceBetween={'10'}
        rewind={false}
        navigation={false}
        pagination={{
          enabled: true,
          clickable: true
        }}
        modules={[Pagination, Navigation]}
        className="course_landing_image_gallery_mobile"
      >
      {
        images.map((image, index) => {

          return (
            <SwiperSlide key={image.image}>
              <img className="course_landing_image_gallery_image_mobile" alt={image.title} src={image.image} loading="lazy" />
            </SwiperSlide>
          );

        })
      }
      </Swiper>
    );

  return (
    <div className="course_landing_image_gallery row gy-4">

      {
        images.map((image) => {

          return (
            <div key={image.image} className="course_landing_image_gallery_image_container col-sm-4">
              <img className="course_landing_image_gallery_image" alt={image.title} src={image.image} loading="lazy" />
            </div>
          );

        })
      }

    </div>
  );
};
